var default_styles_default = {
  "button_container": "_2P7VN",
  "button_text": "HlqZ9",
  "button_size_content": "d-Ptz"
};
export {
  default_styles_default as default
};
//# sourceMappingURL=default-styles-scss.js.map
